
import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config/config";
import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import { CCollapse, CLink } from "@coreui/react";
// import config from "../../../config/config";

const MultiSiteModule = (props) => {
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [multiSiteListing, setMultiSiteListing] = useState([]);
  const [visible, setVisible] = useState(false);

  console.log(formValues, "dcjdjdxcdshjcbdhbchdbchd")
  console.log(multiSiteListing, "multiSiteListing")

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const mapEnableMultiSiteData = (multiSiteList, enableModuleData) => {
    const siteConfig = [];
    const values = {
    MainSiteEnable: true,
    ActiveSite: "MainSite",
    }
    console.log(multiSiteList, "kdnjcvdfnv")

    multiSiteList.forEach((site, index) => {
      const label = site.AppConfigkey?.trim();
      console.log(site, "djkvbnjfbvfbvhfbvhvbhvbf")
      let nameKey = "";
      let aliasKey = "";
      let enableKey = "";
      let radioValue = "";

      if (index === 0) {
        nameKey = "DefaultSite";        // instead of MainSiteAlias
        aliasKey = "MainSiteAlias";  
        enableKey = "MainSiteEnable";
        radioValue = "MainSite";
      } else {
        nameKey = `SiteName${index}`;
        aliasKey = `SiteAlias${index}`;
        enableKey = `SiteEnable${index}`;
        radioValue = site?.AppConfigkey;
        // radioValue = index === 1 ? "SecondSite" : "ThirdSite";
      }

      enableModuleData.forEach((data) => {
        const key = data.AppConfigkey?.trim();
        const val = data.AppConfigvalue;
        if (key === nameKey) values[nameKey] = val;
        if (key === aliasKey) values[aliasKey] = val;

        if (key === enableKey)
          values[enableKey] = ["true", true, "1", 1].includes(val);
        if (key === "ActiveSite") values.ActiveSite = val;
      });

      siteConfig.push({
        label,
        nameKey,
        aliasKey,
        enableKey,
        radioValue,
        isMain: index === 0,
      });
    });

    return { siteConfig, values };
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      
      // Prepare the payload in the required format
      const formArray = [];
      
      // Add configuration for each site
      multiSiteListing.forEach((site, index) => {
        if (site.isMain) {
          formArray.push(
            { AppConfigkey: "MainSiteAlias", AppConfigvalue: formValues["MainSiteAlias"] || config?.ecommWebsiteUrl || "" },
            { AppConfigkey: "MainSiteEnable", AppConfigvalue: true }
          );
        } else {
          const siteNumber = index;
          formArray.push(
            { AppConfigkey: `SiteName${siteNumber}`, AppConfigvalue: formValues[`SiteName${siteNumber}`] || "" },
            { AppConfigkey: `SiteEnable${siteNumber}`, AppConfigvalue: formValues[`SiteEnable${siteNumber}`] || false },
            { AppConfigkey: `SiteAlias${siteNumber}`, AppConfigvalue: formValues[`SiteAlias${siteNumber}`] || "" }
          );
        }
      });

      // Add ActiveSite configuration
      formArray.push(
        { AppConfigkey: "ActiveSite", AppConfigvalue: formValues.ActiveSite || "FirstSite" },
        { AppConfigkey: "DefaultSite", AppConfigvalue: config?.ecommWebsiteUrl || config?.ecommWebsiteUrl }
      );

      const payload = {
        type: "EnableMultiSiteModule",
        storeconfigxml: JSON.stringify({ StoreConfig: formArray }),
      };

      const response = await axios.post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.data.ResponseCode === "SUCCESS" && response.data.ResponseID > 0) {
        toastSuccess(SUCCESS_MESSAGE);
      } else {
        toastError(ERROR_MESSAGE);
      }
    } catch (error) {
      toastError("Failed to save configuration.");
      console.error("Error saving configuration:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [res1, res2] = await Promise.all([
          axios.get(
            `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=MultiSiteListing`,
            { headers: { Authorization: token } }
          ),
          axios.get(
            `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=EnableMultiSiteModule`,
            { headers: { Authorization: token } }
          ),
        ]);

        const multiList = res1.data.ResponseData || [];
        const enableList = res2.data.ResponseData || [];

        console.log(multiList, "check multilist")
        const { siteConfig, values } = mapEnableMultiSiteData(
          multiList,
          enableList
        );
        setMultiSiteListing(siteConfig);
        setFormValues((prev) => ({ ...prev, ...values }));
      } catch (error) {
        toastError("Failed to load configuration.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
   <div className="card">
  <div className="card-header">
    <h5 className="card-title">
      <CLink
        onClick={() => setVisible(!visible)}
        style={{ color: "var(--primary-main-color)", cursor: "pointer" }}
      >
        Multi Site Module
      </CLink>
    </h5>
  </div>
  <CCollapse visible={visible || props.visibleCurrencyChange}>
    <div className="card-body">
      <div className="">
        {/* <h5 className="mb-3">Multi-Site Configuration</h5> */}
        {multiSiteListing.map((field, index) => (
          <div className="form-group row align-items-center mb-3" key={index}>
            <label className="col-sm-2 col-form-label" htmlFor={field.nameKey}>
              {formValues[field.aliasKey] || field.label}
            </label>

            <div className="col-sm-4">
              <input
                type="text"
                className="form-control form-control-sm"
                name={field.nameKey}
                value={formValues[field.nameKey] || ""}
                onChange={handleChange}
                disabled={field.isMain}
                placeholder={`${formValues[field.aliasKey] || field.label} URL`}
              />
            </div>

            <div className="col-sm-2">
              <input
                type="text"
                className="form-control form-control-sm"
                name={field.aliasKey}
                value={formValues[field.aliasKey] || ""}
                onChange={handleChange}
                // disabled={field.isMain}
                placeholder={`${field.label} Alias`}
              />
            </div>

            <div className="col-sm-1 d-flex align-items-center">
              <input
                type="checkbox"
                className="form-check-input me-2"
                name={field.enableKey}
                checked={field.isMain ? true : formValues[field.enableKey]}
                onChange={handleChange}
                disabled={field.isMain}
                style={{ width: "20px", height: "20px" }}
              />
            </div>

            <div className="col-sm-3 gap-2 d-flex align-items-center">
              {/* {field.isMain ? ( */}
                {/* <input
                  type="radio"
                  checked
                  disabled
                  className="form-check-input me-2"
                  style={{ width: "20px", height: "20px", marginTop: "4px" }}
                /> */}
              {/* // ) : ( */}
                <input
                  type="radio"
                  name="ActiveSite"
                  value={field.radioValue}
                  checked={formValues.ActiveSite === field.radioValue}
                  onChange={(e) =>
                    setFormValues((prev) => ({
                      ...prev,
                      ActiveSite: e.target.value,
                    }))
                  }
                  className="form-check-input me-2"
                  style={{ width: "20px", height: "20px", marginTop: "4px" }}
                />
              {/* // )} */}
              <label className="mt-3 form-check-label">Active Site</label>
            </div>
          </div>
        ))}

        <div className="row mt-4">
          <div className="col-md-12 text-end">
            <button
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Configuration"}
            </button>
          </div>
        </div>
      </div>
    </div>
  </CCollapse>
</div>

  );
};

export default MultiSiteModule;